export * from './show';

import { Order } from '~/@types/table/order';
import { apiClient } from '~/api/client';
import { CompanyAndAgent } from '~/components/connections/types';

type IndexParams = {
  nmls: string;
  company_type: 'seller' | 'buyer';
  page: number;
  period: Period;
  sort_field: string;
  order: Order;
};

type IndexResponse = {
  data: {
    seller_companies: CompanyAndAgent[];
    seller_companies_count: number;
    seller_companies_volume: number;
    seller_companies_units: number;
    buyer_companies: CompanyAndAgent[];
    buyer_companies_count: number;
    buyer_companies_volume: number;
    buyer_companies_units: number;
  };
};

export const index = async (allParams: IndexParams) => {
  const { nmls, sort_field, order, ...params } = allParams;
  return apiClient.get<IndexResponse>(
    `/loan_officers/${nmls}/realtor_companies?sort[field]=${sort_field}&sort[order]=${order}`,
    { params }
  );
};
